module.exports = __webpack_public_path__ + "img/IT0003131651364.104f4592.png";